import { reduxKey } from './constants';
export function getBirthdayPopupState(state) {
    return state[reduxKey] || {};
}
export function getIsInitialized(state) {
    return getBirthdayPopupState(state).isInitialized || false;
}

//# sourceMappingURL=selectors.js.map